import { render } from "./ExamenCode.vue?vue&type=template&id=c1baa96e&scoped=true"
import script from "./ExamenCode.vue?vue&type=script&lang=js"
export * from "./ExamenCode.vue?vue&type=script&lang=js"

import "./ExamenCode.vue?vue&type=style&index=0&id=c1baa96e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1baa96e"]])

export default __exports__